/**
 * package: com.inq.aria
 * object: AriaUtil
 * @description
 */
com.inq.aria.AriaUtil = {};

/**
 *  Hide elements by a tag name in a container element.
 *
 * @param box     - a parent element contains tag elements
 * @param tagName - element tag name to aria hide
 */
com.inq.aria.AriaUtil.hideTag = function( box, tagName ){
    // Condition Check
    if (!box || typeof box.getElementsByTagName !== "function" || !tagName)
        return;
    
    var tags = box.getElementsByTagName( tagName );

    for (var i = 0; i < tags.length; i++) {
        try {
            tags[i].setAttribute("tabindex", "-1");
            tags[i].setAttribute("aria-hidden", true);
        } catch (err) {
            // Move on to the next element.
        }
    }

    // free resources
    tags = null;
};

